import { createSignal, createEffect, onCleanup } from 'solid-js';

export const scrollToSection = (sectionRef: HTMLElement | null) => {
  if (sectionRef) {
    sectionRef.scrollIntoView({ behavior: 'smooth' });
  } else {
    console.error('SectionRef is not provided');
  }
};

export const useIsScrolled = (threshold = 0) => {
  const [isScrolled, setIsScrolled] = createSignal<boolean>(false);

  createEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      setIsScrolled(scrollPosition > threshold);
    };

    handleScroll();

    window.addEventListener('scroll', handleScroll, { passive: true });
    document.addEventListener('scroll', handleScroll, { passive: true });

    onCleanup(() => {
      window.removeEventListener('scroll', handleScroll);
      document.removeEventListener('scroll', handleScroll);
    });
  });

  return isScrolled;
};
